module.exports = __webpack_public_path__ + "img/s03-min.4b965451.png";